import { render, staticRenderFns } from "./indexOld.vue?vue&type=template&id=00521fb9&scoped=true&"
import script from "./indexOld.vue?vue&type=script&lang=js&"
export * from "./indexOld.vue?vue&type=script&lang=js&"
import style0 from "./indexOld.vue?vue&type=style&index=0&id=00521fb9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00521fb9",
  null
  
)

export default component.exports